import { CONFIG_READY, CONFIG_VALUE, FEATURE_FLAG_VALUE } from '@prosaas/psw-events';
import { emit, getEnvironmentName, subscribe } from '@prosaas/psw-utils';
import { defaultSdkKeys } from '../configs/configCat.configs';
import {
  configCatClientFactory,
  configCatHandlerFactory,
  getConfigCatKey,
} from '../factories/configCat.factories';
import type { ICategoryName } from '../interfaces/configCat.interfaces';

const categoryList: ICategoryName[] = ['config', 'featureFlag'];
const events: Record<ICategoryName, string> = {
  config: CONFIG_VALUE,
  featureFlag: FEATURE_FLAG_VALUE,
};

const configReady = categoryList.map((category) => {
  const defaultsSdkKey = getConfigCatKey(defaultSdkKeys, category, getEnvironmentName());
  const defaultsClient = configCatClientFactory(defaultsSdkKey);

  const event = events[category];
  const handler = configCatHandlerFactory(defaultsClient, events[category]);

  subscribe(event, handler, { skipReplay: true });

  return Promise.resolve();
});

Promise.all(configReady).then(() => emit(CONFIG_READY, true));
